

















import { Component, Vue } from "vue-property-decorator";
import { Item } from "@/game/Models/item";

@Component
export default class Currency extends Vue {
  declareer() {
    this.$store.commit("declareer");
  }

  registreer() {
    this.$store.commit("registreer");
  }

  herdeclareren() {
    this.$store.commit("herdeclareren");
  }

  get declaraties(): number {
    return this.$store.state.declaraties;
  }

  get facturen(): number {
    return this.$store.state.facturen;
  }

  get afgekeurdeDeclaraties(): number {
    return this.$store.state.afgekeurdeDeclaraties;
  }

  get dps(): number {
    return this.$store.state.dps;
  }

  get rps(): number {
    return this.$store.state.rps;
  }

  get failureChance(): number {
    return this.$store.state.failureChance;
  }

  get datum(): string {
     const monthNames = [
      "januari", "februari", "maart",
      "april", "mei", "juni", "juli",
      "augustus", "september", "oktober",
      "november", "december"
    ];
    const date = new Date();
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    return `${monthNames[monthIndex]} ${year}`;
  }
}
